import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getGlobalConfigQueryKey from './get-query-key';

// Since we webshell isn't supporting global config until v6 we need a fallback that uses the old determination for global store based on merch group so we dont break downstream consumers still on v5.
// When all teams upgrade to web shell v6, we can remove this fallback and just reference window?.getGlobalConfig
var webShellLocaleFallback = function webShellLocaleFallback() {
  return new Promise(function (resolve) {
    var _window$webShellClien, _merchGroup$toUpperCa;
    var _ref = ((_window$webShellClien = window.webShellClient) === null || _window$webShellClien === void 0 || (_window$webShellClien = _window$webShellClien.locale) === null || _window$webShellClien === void 0 ? void 0 : _window$webShellClien.get()) || {},
      merchGroup = _ref.merchGroup;
    var isGlobalStoreCountry = (merchGroup === null || merchGroup === void 0 || (_merchGroup$toUpperCa = merchGroup.toUpperCase()) === null || _merchGroup$toUpperCa === void 0 ? void 0 : _merchGroup$toUpperCa.indexOf('X')) > -1;
    resolve({
      isGlobalStoreCountry: isGlobalStoreCountry
    });
  });
};
/**
 * @typedef {Object} GlobalConfig - the global config object
 * @property {boolean} - isGlobalStoreCountry - whether the current country is a global store
 * @property {boolean} - useMarketplaceId - whether the current country is a marketplace
 * @property {boolean} - asyncChatEnabled - whether async chat is enabled
 */

/**
 * Fetches the global config object
 * @returns {Promise<GlobalConfig>} - the global config object
 */
var getGlobalConfigPatch = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _window, globalConfig;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(window.getGlobalConfig === undefined)) {
            _context.next = 2;
            break;
          }
          _context.next = 1;
          return webShellLocaleFallback();
        case 1:
          return _context.abrupt("return", _context.sent);
        case 2:
          _context.next = 3;
          return (_window = window) === null || _window === void 0 ? void 0 : _window.getGlobalConfig();
        case 3:
          globalConfig = _context.sent;
          return _context.abrupt("return", globalConfig.config ? globalConfig.config : globalConfig);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getGlobalConfigPatch() {
    return _ref2.apply(this, arguments);
  };
}();
var getFetchGlobalConfigOptions = function getFetchGlobalConfigOptions() {
  return {
    queryKey: getGlobalConfigQueryKey(),
    queryFn: getGlobalConfigPatch,
    // replace with window?.getGlobalConfig when all teams upgrade to web shell v6
    placeholderData: {}
  };
};
export { getGlobalConfigPatch };
export default getFetchGlobalConfigOptions;